<template>
  <div>
    <div>
      <span>
        <i class="f7-icons standardIconWidth"> info_circle_fill </i>
        <span class="infoIconText">
          {{ $t('samplesRegister.minimumOrderHandlingFee') }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
